export default __webpack_public_path__ + "static/cob-415fa94dbb74fc44440951da8e946c72.png";